var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "badge badge-purple mr-1" }, [
    _c("i", { staticClass: "fas fa-filter mr-1" }),
    _vm._v("\n    " + _vm._s(_vm.content) + "\n  "),
    _c("i", {
      staticClass: "fas fa-window-close ml-1 cursor-pointer",
      on: { click: _vm.clear },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }